<!-- <p>card-creation works!</p> -->
<!-- <p>{{userid}}</p> -->

<!--
<div class="row" *ngIf="firebaseService.userData as user">
  <div class="col-md-12">
    <div class="media">
      <div class="media-body">
        <h1>Hello: <strong>{{(user.displayName) ? user.displayName : 'Super Admin'}}</strong></h1>
        <p>User ID: <strong>{{user.uid}}</strong></p>
        <p>Email: <strong>{{user.email}}</strong></p>
        <p>Email Verified: <strong>{{user.emailVerified}}</strong></p>
      </div>
    </div>
  </div>
</div> -->

<main id="agent">
  <i (click)="mob_click()" id="mobia" class="bi bi-list mobile-nav-toggle2 d-xl-none"></i>

  <header id="header2">
    <div class="d-flex flex-column">

      <div class="profile">
        <img src={{profileurl}} alt="" class="img-fluid rounded-circle">
        <h1 class="text-light"><a href="#">{{(username) ? username : 'Super Employee'}}</a></h1>
        <!-- <div class="social-links mt-3 text-center">
          <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
          <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
          <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
          <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
          <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
        </div> -->
      </div>

      <nav id="navbar2" class="nav-menu2 navbar2">
        <ul>
          <li><a href="/agent#hero2" class="nav-link scrollto active"><i class="bx bx-home"></i> <span>Home</span></a></li>
          <li><a href="/agent#profile" class="nav-link scrollto"><i class="bx bx-user"></i> <span>Profile</span></a></li>
          <li id="navagentaltpay"><a href="/agent#alteragentpayment" class="nav-link scrollto"><i class="bx bx-user"></i> <span>Payment Details</span></a></li>
          <li id="navagentpay"><a href="/agent#agentpayment" class="nav-link scrollto"><i class="bx bx-user"></i> <span>Payment Details</span></a></li>
          <li><a href="/agent#share" class="nav-link scrollto"><i class="bx bx-share"></i> <span>Share Your Code</span></a></li>
          <li><a href="/agent#reports" class="nav-link scrollto"><i class="bx bx-server"></i> <span>Reports</span></a></li>
          <li><a href="#" (click)="loggedout()" class="nav-link scrollto"><i class="bx bx-log-out"></i> <span>Logout</span></a></li>
        </ul>
      </nav><!-- .nav-menu -->
    </div>
  </header><!-- End Header -->

  <!-- ======= Hero Section ======= -->
  <section id="hero2" class="d-flex flex-column justify-content-center align-items-center">
    <div class="hero-container2" data-aos="fade-in">
      <h1>{{username}}</h1>
    </div>
  </section>
<section id="profile" class="contact">
<div class="container">
  <div class="section-title">
    <h2>Add Profile Photo</h2>
  </div>
  <div class="row">
    <div class="col-md-6 form-group">
      <input type="file" (change)="selectAgentProfFile($event)" name="profimage" class="form-control" id="profimage" required>
    </div>
    <div class="col-md-3 form-group">
      <button class="btn btn-success" [disabled]="!selectedAgentProfFiles" (click)="upload()">Upload</button>
    </div>
    <div class="col-md-3 form-group">
      <div *ngIf="currentFileAgentProfUpload" class="progress">
        <div class="progress-bar progress-bar-info progress-bar-striped" style="width: 100%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
             role="progressbar" attr.aria-valuenow="{{percentageAgentProf}}"
             aria-valuemin="0" aria-valuemax="100">
          {{percentageAgentProf}}%
        </div>
      </div>
     </div>

  </div>
</div>
</section>


<section id="profile" class="contact">
  <div class="container" data-aos="fade-up">

    <div class="section-title">
      <h2>Your Details</h2>

    </div>

    <div class="row mt-1">

      <div class="col-lg-12 mt-5 mt-lg-0">
          <div class="row">
            <div class="col-md-6 form-group">
              <label>Name:</label>
            </div>
            <div class="col-md-6 form-group">
              <p>{{userfirstname}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label>Email:</label>
            </div>
            <div class="col-md-6 form-group">
              <p>{{email}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 form-group">
              <label>Reference Code:</label>
            </div>
            <div class="col-md-6 form-group">
              <p id="userrefcode">{{useragentrefcode}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 form-group">
              <label>Phone:</label>
            </div>
            <div class="col-md-6 form-group">
              <p>{{phone}}</p>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6 form-group">
              <label>Alternative No:</label>
            </div>
            <div class="col-md-6 form-group">
              <p>{{aphone}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 form-group">
              <label>Aadhar No:</label>
            </div>
            <div class="col-md-6 form-group">
              <p>{{useragentaadhar}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 form-group">
              <label>Address:</label>
            </div>
            <div class="col-md-6 form-group">
              <p>{{address}}</p>
            </div>
          </div>

      </div>

    </div>

  </div>
</section>
<!--
gpayname!:string;
  gpay!:string;
  phpename!:string;
  phpe!:string;
  bankname!:string;
  accholname!:string;
  accnu!:string;
  ifsc!:string;
  sorc!:string; -->
  <section id="alteragentpayment" class="contact">
    <div class="container" >

      <div class="section-title">
        <h2>Payment Details</h2>

      </div>

      <div class="row mt-1">

        <div class="col-lg-12 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Gpay Name:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{gpayname}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>gpay:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{gpay}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>PhonePe Name:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{phpename}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>PhonePe:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{phpe}}</p>
              </div>
            </div>


            <div class="row">
              <div class="col-md-6 form-group">
                <label>Bank Name:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{bankname}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>Account Holder Name:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{accholname}}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>Account No:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{accnu}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>IFSC CODE:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{ifsc}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>SA/CU:</label>
              </div>
              <div class="col-md-6 form-group">
                <p>{{sorc}}</p>
              </div>
            </div>

        </div>

      </div>

    </div>
  </section>
<section id="agentpayment" class="contact">
  <div class="container" data-aos="fade-up">

    <div class="section-title">
      <h2>Payments Details</h2>
    </div>

    <div class="row mt-1">

      <div class="col-lg-12 mt-5 mt-lg-0">

        <form (ngSubmit)="agent_payment_det(paymentForm.value,appagentemail.value)" [formGroup]="paymentForm" class="php-email-form">
          <input type="hidden" #appagentemail value={{email}}/>
          <div class="row">
            <div class="col-md-3 form-group">
              <input type="text" name="gpayname" formControlName="gpayname" class="form-control" id="gpayname" placeholder="Gpay User Name" required>
            </div>
            <div class="col-md-3 form-group">
              <input type="text" name="gpay" formControlName="gpay" class="form-control" id="gpay" placeholder="UPI ID" required>
            </div>
            <div class="col-md-3 form-group">
              <input type="text" name="phpename" formControlName="phpename" class="form-control" id="phpename" placeholder="Phonepe User Name" required>
            </div>
            <div class="col-md-3 form-group">
              <input type="text" name="phpe" formControlName="phpe" class="form-control" id="phpe" placeholder="PhonePe UPI ID" required>
            </div>
      <p>Bank Account details.</p>

            <div class="col-md-6 form-group">
              <input type="text" name="bankname" formControlName="bankname" class="form-control" id="bankname" placeholder="Bank Name" required>
            </div>
            <div class="col-md-6 form-group">
              <input type="text" name="accholname" formControlName="accholname" class="form-control" id="accholname" placeholder="Account Holder Name" required>
            </div>
            <div class="col-md-6 form-group">
              <input type="text" name="accnu" formControlName="accnu" class="form-control" id="accnu" placeholder="Account Number" required>
            </div>
            <div class="col-md-6 form-group">
              <input type="text" name="ifsc" formControlName="ifsc" class="form-control" id="ifsc" placeholder="IFSC Code" required>
            </div>
            <div class="col-md-6 form-group">
              <input type="text" name="sorc" formControlName="sorc" class="form-control" id="sorc" placeholder="Savings/ Current" required>
            </div>
          <div class="my-3">
            <div class="error-message"></div>
            <div  id="pay-succ" class="display_none">Details Saved Successfully. Thank you!</div>
          </div>
          <div class="text-center"><button type="submit">Save</button></div>
          </div>
        </form>

      </div>

    </div>

  </div>
</section>

<section id="reports" class="why-us section-bg">
  <div class="container-fluid" data-aos="fade-up">
    <div class="container" data-aos="fade-in">
      <div class="section-title">
        <h2>Reports</h2>
      </div>
    </div>


    <div class="row">

      <div class="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">

        <div class="row">
          <div class="col">
            <button class="btn-reports"><a href="/cards-reffered" target="blank">Total Cards You Reffered</a></button>
          </div>
        </div>



      </div>

    </div>
</div>
</section>

  </main>
